module.exports = __webpack_public_path__ + "img/woo.0a2d3f77.png";